module.exports = __webpack_public_path__ + "img/speaker-GeorgeKipiani-imgs.6cb674ab.png";